import { listTileReducerFactory } from "../../../pillar/dashboard/store/reducers/list-tile.reducerFactory";
import { ModuleConfiguration } from "../../datawarehouse.module.config";
import { ModelBase } from "../../../pillar/common/models/ModelBase";
import { IDataWarehouseEditorState } from "../states/IDataWarehouseEditorState";
import * as actions from "../actions";
import { GetEntityListMetadataSuccessAction } from "../actions";
import { DataWarehouseWorkspaceModelResponse } from "../../models/DataWarehouseWorkspaceModelResponse";
import { TileState } from "../../../pillar/dashboard/store/state/TileState";
import { IMetadataListEditorState } from "../../../pillar/workspace/store/states/IMetadataListEditorState";
import * as errorActions from '../../../pillar/common/actions/ActionError';

var initialState: IDataWarehouseEditorState = {
    listEditors: {},
    submittingEntity: null
}

var tileStateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, ModelBase, DataWarehouseWorkspaceModelResponse, new TileState<any, any>());

export function dataWarehouseEditorReducer(state = initialState, action: actions.EntityActions): IDataWarehouseEditorState {
    var listEditor: IMetadataListEditorState;
    var listEditorChanged = false;
    if ((action.type.toLowerCase().indexOf(`[${ModuleConfiguration.moduleName}]`) >= 0 )
         && action.payload && action.payload.entityKey && action.payload.scope) {
        var key = `${action.payload.entityKey}_${action.payload.scope}`;
        if (!state.listEditors.hasOwnProperty(key)) {
            state.listEditors[key] = {
                list: [],
                currentPage: 0,
                totalCount: 0,
                loading: true,
                errors: [],
                selected: undefined,
                listMetadata: undefined,
                submittingEntityKey: null
            };
        }
        listEditor = state.listEditors[key];
    }
    switch (action.type) {
        case actions.SUBMITTING_ENTITY_SELECTED:
            var selectedAction = (action as any) as actions.SubmittingEntitySelectedAction;
            state = {
                ...state,
                submittingEntity: selectedAction.payload.submittingEntity
            }
            break;
        case actions.REVISE_ROOT_ENTITY:
        case actions.GET_ENTITY_LISTMETADATA:
            var listEditor = {
                ...listEditor,
                loading: true
            };
            listEditorChanged = true;
            break;
        case actions.REVISE_ROOT_ENTITY_RESPONSE:
            var listEditor = {
                ...listEditor,
                loading: false
            };
            listEditorChanged = true;
            break;
        case actions.GET_ENTITY_LISTMETADATA_SUCCESS:
            var listMetadataAction = action as GetEntityListMetadataSuccessAction;
            var listEditor = {
                ...listEditor,
                loading: false,
                listMetadata: listMetadataAction.payload.metadata
            };
            listEditorChanged = true;
            break;
        case actions.ADD_WORKSPACE:
            
            break;
        case errorActions.ACTION_ERROR:
          var listEditor = {
            ...listEditor,
            loading: false
          };
          listEditorChanged = false;
          break;
        default:
            if (listEditor) {
                var tileState = tileStateReducer(listEditor, action);
                if (tileState != listEditor) {
                    listEditor = tileState as any;
                    listEditorChanged = true;
                }
            }
            break;
    }
    if (listEditorChanged) {
        var listEditors = {
            ...state.listEditors
        };
        listEditors[key] = listEditor;
        return {
            ...state,
            listEditors: listEditors
        }
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/reducers/datawarehouse-editor.reducer.ts